<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="1163" :height="981 + surveyCategoryBlockHeight + 56" :viewBox="`0 0 1163 ${981 + surveyCategoryBlockHeight + 56}`">
		<g fill="none" fill-rule="evenodd" transform="translate(56 56)">
			<rect width="1051" height="324" fill="#FBFBFB" fill-rule="nonzero" rx="16"></rect>
			<text fill="#555" fill-rule="nonzero" font-family="Helvetica" font-size="22">
				<tspan x="30" y="47.632">Utilisateurs, organisations et promotions</tspan>
			</text>
			<g fill-rule="nonzero" transform="translate(30 94)">
				<rect width="233" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="116.5" y="43.18" text-anchor="middle">{{ trackingData.usersData.count }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="32.23" y="67.084">UTILISATEURS INSCRITS</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(282 94)">
				<rect width="233" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="116.5" y="43.18" text-anchor="middle">{{ trackingData.usersData.waitingCount }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="22" y="67">UTILISATEURS EN ATTENTE</tspan>
				</text>
				<path fill="#555" d="M216,10 C219.87,10 223,13.134 223,17 C223,20.866 219.87,24 216,24 C212.13,24 209,20.866 209,17 C209,13.134 212.13,10 216,10 Z"></path>
				<text fill="#FFF" font-family="Helvetica" font-size="9">
					<tspan x="214" y="20">?</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(536 94)">
				<rect width="233" height="91" fill="#006FB7" rx="16"></rect>
				<text fill="#FFF" font-family="Helvetica" font-size="30">
					<tspan x="116" y="43.18" text-anchor="middle">{{ trackingData.usersData.activeCount }}</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="27.055" y="67.084">UTILISATEURS EN COURS</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(788 94)">
				<rect width="233" height="91" fill="#6FB700" rx="16"></rect>
				<text fill="#FFF" font-family="Helvetica" font-size="30">
					<tspan x="116.75" y="43.18" text-anchor="middle">{{ trackingData.usersData.finishedCount }}</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="10" y="67">UTILISATEURS AYANT TERMINÉ</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(30 204)">
				<rect width="233" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="116.5" y="43.18" text-anchor="middle">{{ trackingData.organizationsData.count }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="57.391" y="67.084">ORGANISATIONS</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(282 204)">
				<rect width="233" height="91" x=".75" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="116.5" y="43.18" text-anchor="middle">{{ trackingData.groupsData.count }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="68.316" y="67.084">PROMOTIONS</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(535 204)">
				<rect width="233" height="91" x=".5" fill="#56CCF2" rx="16"></rect>
				<text fill="#FFF" font-family="Helvetica" font-size="30">
					<tspan x="116.5" y="35.18" text-anchor="middle">{{ trackingData.groupsData.collectiveCount }}</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="55.707" y="59.084">PROMOTIONS EN</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="17.181" y="75.084">PLANIFICATION COLLECTIVE</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(788 204)">
				<rect width="233" height="91" x=".25" fill="#56CCF2" rx="16"></rect>
				<text fill="#FFF" font-family="Helvetica" font-size="30">
					<tspan x="116.5" y="35.18" text-anchor="middle">{{ trackingData.groupsData.individualCount }}</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="55.457" y="59.084">PROMOTIONS EN</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="11.579" y="75.084">PLANIFICATION INDIVIDUELLE</tspan>
				</text>
			</g>
			<rect width="1051" height="324" y="344" fill="#FBFBFB" fill-rule="nonzero" rx="16"></rect>
			<text fill="#555" fill-rule="nonzero" font-family="Helvetica" font-size="22">
				<tspan x="30" y="391.632">Parcours</tspan>
			</text>
			<text fill="#555" fill-rule="nonzero" font-family="Helvetica" font-size="22">
				<tspan x="30" y="476.632">Parcours plusieurs</tspan>
			</text>
			<text fill="#555" fill-rule="nonzero" font-family="Helvetica" font-size="22">
				<tspan x="30" y="500.632">niveaux</tspan>
			</text>
			<g fill-rule="nonzero" transform="translate(250 438)">
				<rect width="244" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="122" y="43.18" text-anchor="middle">{{ trackingData.coursesData.completCount }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="73.066" y="67.084">PROMOTIONS</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(513 438)">
				<rect width="244" height="91" x=".667" fill="#006FB7" rx="16"></rect>
				<text fill="#FFF" font-family="Helvetica" font-size="30">
					<tspan x="122" y="43.18" text-anchor="middle">{{ trackingData.coursesData.completActiveCount }}</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="34.875" y="67.084">PROMOTIONS EN COURS</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(777 438)">
				<rect width="244" height="91" x=".333" fill="#6FB700" rx="16"></rect>
				<text fill="#FFF" font-family="Helvetica" font-size="30">
					<tspan x="122" y="43.18" text-anchor="middle">{{ trackingData.coursesData.completFinishedCount }}</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="31.162" y="67.084">PROMOTIONS TERMINÉES</tspan>
				</text>
			</g>
			<text fill="#555" fill-rule="nonzero" font-family="Helvetica" font-size="22">
				<tspan x="30" y="598.632">Parcours 1 niveau</tspan>
			</text>
			<g fill-rule="nonzero" transform="translate(250 548)">
				<rect width="244" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="122" y="43.18" text-anchor="middle">{{ trackingData.coursesData.blockCount }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="73.066" y="67.084">PROMOTIONS</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(513 548)">
				<rect width="244" height="91" x=".667" fill="#006FB7" rx="16"></rect>
				<text fill="#FFF" font-family="Helvetica" font-size="30">
					<tspan x="122" y="43.18" text-anchor="middle">{{ trackingData.coursesData.blockActiveCount }}</tspan>
				</text>
				<text fill="#FFF" font-family="Helvetica" font-size="14">
					<tspan x="34.875" y="67.084">PROMOTIONS EN COURS</tspan>
				</text>
			</g>
			<rect width="244" height="91" x="777.333" y="548" fill="#6FB700" fill-rule="nonzero" rx="16"></rect>
			<text fill="#FFF" fill-rule="nonzero" font-family="Helvetica" font-size="30">
				<tspan x="899.333" y="591.18" text-anchor="middle">{{ trackingData.coursesData.blockFinishedCount }}</tspan>
			</text>
			<text fill="#FFF" fill-rule="nonzero" font-family="Helvetica" font-size="14">
				<tspan x="808.162" y="615.084">PROMOTIONS TERMINÉES</tspan>
			</text>
			<rect width="1051" height="214" y="688" fill="#FBFBFB" fill-rule="nonzero" rx="16"></rect>
			<text fill="#555" fill-rule="nonzero" font-family="Helvetica" font-size="22">
				<tspan x="30" y="735.632">Connexions et réussites</tspan>
			</text>
			<g fill-rule="nonzero" transform="translate(30 782)">
				<rect width="317" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="158.5" y="43.18" text-anchor="middle">{{ pdfTemplate.formatValue(trackingData.activityData.totalTime, 'time') }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="63.897" y="67.084">DE FORMATION DÉLIVRÉES</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(367 782)">
				<rect width="317" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="42" y="59">TEMPS PASSÉ POUR COMPLÉTER</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="68" y="75">UN SCÉNARIO (MOYENNE)</tspan>
				</text>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="158.5" y="35.18" text-anchor="middle">{{ pdfTemplate.formatValue(trackingData.activityData.averageScenarioTime, 'time') }}</tspan>
				</text>
				<path fill="#555" d="M300,10 C303.87,10 307,13.134 307,17 C307,20.866 303.87,24 300,24 C296.13,24 293,20.866 293,17 C293,13.134 296.13,10 300,10 Z"></path>
				<text fill="#FFF" font-family="Helvetica" font-size="9">
					<tspan x="297.75" y="20">?</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(704 782)">
				<rect width="317" height="91" fill="#FFF" rx="16"></rect>
				<text fill="#555" font-family="Helvetica" font-size="30">
					<tspan x="158.5" y="35.18" text-anchor="middle">{{ pdfTemplate.formatValue(trackingData.activityData.averageSuccessRate, 'percentage') }}</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="45.273" y="59.084">DE RÉUSSITE SUR NOS MISES EN</tspan>
				</text>
				<text fill="#B7B7B7" font-family="Helvetica" font-size="14">
					<tspan x="77.544" y="75.084">SITUATION (MOYENNE)</tspan>
				</text>
				<path fill="#555" d="M300,10 C303.87,10 307,13.134 307,17 C307,20.866 303.87,24 300,24 C296.13,24 293,20.866 293,17 C293,13.134 296.13,10 300,10 Z"></path>
				<text fill="#FFF" font-family="Helvetica" font-size="9">
					<tspan x="297.75" y="20">?</tspan>
				</text>
			</g>
			<g fill-rule="nonzero" transform="translate(910 721)">
				<polygon fill="#404040" points="94.005 57 103.005 66 85.005 66" transform="matrix(1 0 0 -1 0 123)"></polygon>
				<rect width="187" height="58" fill="#404040" rx="8"></rect>
				<g fill="#FFF" font-family="Helvetica" font-size="12" transform="translate(17 8)">
					<text>
						<tspan x="6.797" y="11">% moyen de réussite pour</tspan>
					</text>
					<text>
						<tspan x=".466" y="25">les utilisateurs ayant terminé</tspan>
					</text>
					<text>
						<tspan x="41.484" y="39">leur parcours</tspan>
					</text>
				</g>
			</g>
			<g fill-rule="nonzero" transform="translate(573 721)">
				<polygon fill="#404040" points="94.005 57 103.005 66 85.005 66" transform="matrix(1 0 0 -1 0 123)"></polygon>
				<rect width="187" height="58" fill="#404040" rx="8"></rect>
				<g fill="#FFF" font-family="Helvetica" font-size="12" transform="translate(24 8)">
					<text>
						<tspan x=".799" y="11">Pour la première tentative</tspan>
					</text>
					<text>
						<tspan x="9.125" y="25">aboutie concernant les</tspan>
					</text>
					<text>
						<tspan x="39.491" y="39">MES et VT.</tspan>
					</text>
				</g>
			</g>
			<g fill-rule="nonzero" transform="translate(444 21)">
				<polygon fill="#404040" points="54.005 69 63.005 78 45.005 78" transform="matrix(1 0 0 -1 0 147)"></polygon>
				<rect width="187" height="70" fill="#404040" rx="8"></rect>
				<g fill="#FFF" font-family="Helvetica" font-size="12" transform="translate(19 7)">
					<text>
						<tspan x="6.131" y="11">Les utilisateurs inscrits qui ne</tspan>
					</text>
					<text>
						<tspan x="7.115" y="25">sont pas dans une promotion</tspan>
					</text>
					<text>
						<tspan x=".441" y="39">ou qui sont dans une promotion</tspan>
					</text>
					<text>
						<tspan x="2.788" y="53">qui n’a pas encore commencé.</tspan>
					</text>
				</g>
			</g>

			<CategoryBlock
				title="Résultats des sondages"
				:y="925"
				:height="surveyCategoryBlockHeight"
			>
				<text v-if="!trackingData.coursesSurveys.length">
					<tspan x="30" y="75">Aucun résultats pour le moment</tspan>
				</text>

				<SurveyResultsBlock
					v-for="(survey, index) in trackingData.coursesSurveys"
					:key="survey.id"
					:survey="survey"
					:surveyIndex="index"
					:questionBlockPositionBySurveyIndex="questionBlockPositionBySurveyIndex"
					:surveyBlockHeightByIndex="surveyBlockHeightByIndex"
					:questionTextHeight="surveyQuestionTextHeight"
					:questionTextMarginBottom="surveyQuestionTextMarginBottom"
					:answerHeight="surveyAnswerHeight"
					:surveyQuestionTextCharLimit="surveyQuestionTextCharLimit"
					:surveyAnswerCharLimit="surveyAnswerCharLimit"
					:class="{ 'mb-8': index < trackingData.coursesSurveys.length - (2 - trackingData.coursesSurveys.length % 2) }"
				/>
			</CategoryBlock>
		</g>
	</svg>
</template>

<script>
	import pdfTemplate from '@/utils/pdfTemplate'

	import CategoryBlock from "./CategoryBlock"

	import SurveyResultsBlock from "./SurveyResultsBlock"

	export default {
		name: 'MainPDFTemplate',
		components: {
			CategoryBlock,
			SurveyResultsBlock,
		},
		props: {
			trackingData: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				pdfTemplate,
				surveyQuestionTextHeight: 19,
				surveyQuestionTextMarginBottom: 8,
				surveyQuestionTextCharLimit: 64,
				surveyAnswerCountHeight: 17,
				surveyAnswerHeight: 20,
				surveyAnswerMarginBottom: 4,
				surveyAnswerCharLimit: 51,
				questionMarginBottom: 16,
			}
		},
		computed: {
			questionBlockPositionBySurveyIndex() {
				return this.trackingData.coursesSurveys.reduce((list, survey) => {
					list.push(
						// Compute position (y & height) for each question "block"
						survey.questions.reduce((list, question, index) => {
							const previousBlock = (index > 0 ? list[index - 1] : { y: 62, height: 0 })

							// Compute question text height to handle multiline text wrap
							const questionTextHeight = pdfTemplate.getEstimatedTextHeight(question.text, this.surveyQuestionTextHeight, this.surveyQuestionTextCharLimit)

							// Compute answers position to handle multiline text wrap
							const answerPositionByIndex = question.answers.reduce((list, answer, index) => {
								const previousAnswerPos = (index > 0 ? list[index - 1] : { y: questionTextHeight + this.surveyQuestionTextMarginBottom, height: 0 })

								const textHeight = pdfTemplate.getEstimatedTextHeight(
									answer.text,
									this.surveyAnswerHeight,
									this.surveyAnswerCharLimit
								)

								list.push({
									y: previousAnswerPos.y + previousAnswerPos.height,
									height: textHeight + this.surveyAnswerMarginBottom,
								})

								return list
							}, [])
							const answersHeight = answerPositionByIndex.reduce((total, pos) => total + pos.height, 0)

							list.push({
								y: previousBlock.y + previousBlock.height,
								questionTextHeight,
								answerPositionByIndex,
								answersHeight,
								height: questionTextHeight + this.surveyQuestionTextMarginBottom + answersHeight + this.surveyAnswerCountHeight + this.questionMarginBottom
							})

							return list
						}, [])
					)

					return list
				}, [])
			},
			surveyBlockHeightByIndex() {
				return this.trackingData.coursesSurveys.reduce((list, _survey, index) => {
					const questionBlocksHeight = this.questionBlockPositionBySurveyIndex[index].reduce((height, questionBlockPos) => {
						return height + questionBlockPos.height
					}, 0)

					list.push((20 + 22 + 20 + questionBlocksHeight + 20))

					return list
				}, [])
			},
			surveyBlockRowsHeight() {
				let height = 0

				for (var i = 0; i < this.surveyBlockHeightByIndex.length; i += 2) {
					const firstBlockHeight = this.surveyBlockHeightByIndex[i]
					const secondBlockHeight = this.surveyBlockHeightByIndex[i + 1] || 0

					height += Math.max(firstBlockHeight, secondBlockHeight) + 32
				}

				return height
			},
			surveyCategoryBlockHeight() {
				return 97 + this.surveyBlockRowsHeight
			},
		},
	}
</script>